var _a;
import { __decorate, __metadata } from "tslib";
import template from './ContentTypeView.html';
import { Component } from 'decorators';
import { ContentTypeAddContent } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components/contentType/contentType.dispatcher';
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
let ContentTypeComponent = class ContentTypeComponent {
    static $inject = ['BuilderSegmentService'];
    constructor(BuilderSegmentService) {
        this.BuilderSegmentService = BuilderSegmentService;
    }
    $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
        else {
            throw new Error('onAction is not implemented');
        }
    }
    $onAdd(type) {
        const action = new ContentTypeAddContent({
            type,
        });
        this.$dispatch(action);
    }
};
ContentTypeComponent.$inject = ['BuilderSegmentService'];
ContentTypeComponent = __decorate([
    Component({
        template,
        bindings: {
            type: '@?',
            showText: '<?',
            icon: '@?',
            translateKey: '@?',
            onAction: '&?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _a : Object])
], ContentTypeComponent);
export { ContentTypeComponent };
